import { observer } from 'mobx-react';
import { autoinject, inject, Modal, ModalHandle } from 'Mri.Web.Common';
import * as React from 'react';
import { BsLaptop } from '@react-icons/all-files/bs/BsLaptop';
import { AccountStore } from '../Account/AccountStore';
import { DisplayTerm } from '../Term/DisplayTerm';

export interface ITerminalModalProps {
    readonly serialNumber: string;
    readonly modalHandle: ModalHandle;
    readonly alerts?: string[];
}

@autoinject
@observer
export class TerminalModal extends React.Component<ITerminalModalProps> {
    public render() {
        return (
            <Modal
                className="modal-xl"
                title={this.title}
                modalHandle={this.props.modalHandle}
                footerClass="d-none"
                bodyClass="p-0"
            >
                <DisplayTerm serialNumber={this.props.serialNumber} accessTokenStore={this.accountStore} />
            </Modal>
        );
    }

    @inject
    public accountStore!: AccountStore;

    //Private Fields
    private title = (
        <span className="text-header fw-bold">
            <BsLaptop /> Terminal
        </span>
    );
}
